/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import {InfoItem} from './InfoItem';
import Empty from './Empty';

export function Kids({
                       data = [],
                       className
                     }) {
  const mapKid = (kid, index) => {
    const {
      name,
      ID,
      birthDate,
      inMyCustody,
      receiveAllowance
    } = kid;

    return (
      <div
        key={index}
        className={`mb-2 d-flex justify-content-start flex-column align-items-start col-md-4 col-sm-6 ${className}`}
      >
        <div
          className={'font-weight-bolder font-size-h5 text-dark-75 text-hover-primary text-left'}>
          {name}
        </div>
        <InfoItem
          id={1}
          key={'ID'}
          value={ID}
          translationKey={`userDetails-kids-ID`}
          valueCustomClassName="label label-lg label-light-primary label-inline"
          allowCopy={true}
        />
        <InfoItem
          id={2}
          key={'birthDate'}
          value={birthDate}
          translationKey={`userDetails-kids-birthDate`}
          valueCustomClassName="label label-lg label-light-primary label-inline"
          allowCopy={true}
        />
        <InfoItem
          id={3}
          key={'inMyCustody'}
          value={(
            <div className="font-size-m">
              {
                inMyCustody
                  ? (
                    <img
                      src={toAbsoluteUrl('/media/svg/Check.svg')}
                      alt="in My Custody"
                    />
                  )
                  : (
                    <img
                      src={toAbsoluteUrl('/media/svg/Cross.svg')}
                      alt="not in My Custody"
                    />
                  )
              }
            </div>
          )}
          translationKey={`userDetails-kids-inMyCustody`}
          valueCustomClassName={'text-left'}
        />
        <InfoItem
          id={4}
          key={'receiveAllowance'}
          value={
            receiveAllowance
              ? (
                <img
                  src={toAbsoluteUrl('/media/svg/Check.svg')}
                  alt="receive Allowance"
                />
              )
              : (
                <img
                  src={toAbsoluteUrl('/media/svg/Cross.svg')}
                  alt="not receive Allowance"
                />
              )
          }
          translationKey={`userDetails-kids-receiveAllowance`}
        />

      </div>
    );
  };

  return (
    <>
      <div className={`card card-custom ${className}`}>
        <div
          className="card-header border-0 justify-content-start align-items-center flex-nowrap">
          <img
            src={toAbsoluteUrl('/media/svg/Stairs-blue.svg')}
            className="mr-3" alt="file icon"/>
          <h3 className="card-title font-weight-bolder text-dark">
            <FormattedMessage
              id="userDetails-kids-title"
              defaultMessage="Completed Steps"
            />
          </h3>
        </div>
        <div className="card-body pt-2">
          {
            (data.length === 0)
              ? <Empty/>
              : (
                <>
                  <div className="mb-3 row">
                    {data.map(mapKid)}
                    <div/>
                  </div>
                </>
              )
          }
        </div>
      </div>
    </>
  );
}
